import { api } from '@/lib/api';
import { buildListQueryString, type IListQueryOptions } from '@/lib/build-list-query';
import type {
  IApiResponse,
  IUpcomingFeature,
  IUpcomingFeatureCreate,
  IUpcomingFeatureUpdate,
} from '@skystone/shared';

export type IUpcomingFeatureListOptions = IListQueryOptions;

export const upcomingFeatureApi = {
  getAll: async (options?: IUpcomingFeatureListOptions): Promise<IUpcomingFeature[]> => {
    const result = await api.get<IApiResponse<IUpcomingFeature[]>>(
      `/upcoming-features${buildListQueryString(options)}`,
    );
    return result.data;
  },

  create: async (body: IUpcomingFeatureCreate): Promise<IUpcomingFeature> => {
    const result = await api.post<IApiResponse<IUpcomingFeature>>('/upcoming-features', body);
    return result.data;
  },

  update: async (id: string, body: IUpcomingFeatureUpdate): Promise<IUpcomingFeature> => {
    const result = await api.put<IApiResponse<IUpcomingFeature>>(`/upcoming-features/${id}`, body);
    return result.data;
  },

  setArchived: async (id: string, archived: boolean): Promise<void> => {
    await api.patch<void>(`/upcoming-features/${id}/archive`, { archived });
  },
};
